(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.predictiveSearch = this.querySelector('predictive-search');
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.headerHeight = 0;
      this.fixedActive = false;

      this.updateHeaderMetrics = this.updateHeaderMetrics.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);

      this.updateHeaderMetrics();
      window.addEventListener('load', this.updateHeaderMetrics);
      window.addEventListener('resize', this.updateHeaderMetrics);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.updateHeaderMetrics);

      if (this.headerIsAlwaysSticky) {
        this.activateFixedHeader();
        this.header.style.transform = 'translateY(0)';
        return;
      }

      if (this.stickyType === 'on-scroll-up') {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      }
    }

    updateHeaderMetrics() {
      this.headerHeight = this.header.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      // rt-cls-sticky-slot:v1 - keep the reserved slot in step if the header resizes while fixed
      if (this.fixedActive) this.header.parentElement.style.paddingBottom = this.headerHeight + 'px';
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.updateHeaderMetrics);
      window.removeEventListener('load', this.updateHeaderMetrics);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const delta = scrollTop - this.currentScrollTop;

      if (scrollTop <= this.headerHeight) {
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      this.activateFixedHeader();
      if (delta > 2) {
        this.header.style.transform = `translateY(-${this.headerHeight}px)`;
      } else if (delta < -2) {
        this.header.style.transform = 'translateY(0)';
      }
      this.currentScrollTop = scrollTop;
    }

    activateFixedHeader() {
      if (this.fixedActive) return;
      // rt-cls-sticky-slot:v1 (2026-10-04, RT fix pass E1/T4). Going position:fixed takes the
      // header out of the flow; without this the whole page jumps up by its height (145px on
      // desktop = CLS 0.107 per jump). Reserve the same height on the parent (div.sidebar)
      // in the same frame so nothing below moves. Cleared in reset().
      this.header.parentElement.style.paddingBottom = this.header.offsetHeight + 'px';
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'scrolled-past-header');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.style.position = 'fixed';
      this.header.style.top = '0';
      this.header.style.left = '0';
      this.header.style.right = '0';
      this.header.style.width = '100%';
      this.header.style.zIndex = '1000';
      this.header.style.transition = 'transform 0.15s ease-out';
      this.header.style.transform = 'translateY(0)';
      this.fixedActive = true;
    }

    reveal() {
      // rt-header-reveal:v1 (2026-10-18). Dawn's cart-notification.js calls header.reveal() before it
      // opens the "added to cart" popup, which is rendered INSIDE this header. This class replaced
      // Dawn's StickyHeader (rt-cls-sticky-slot:v1) without that method, so every Add to cart threw
      // "this.header.reveal is not a function", the popup never opened and the cart bubble did not
      // update. Bring a scrolled-away header back on screen; otherwise nothing to do.
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.fixedActive) {
        this.header.style.transform = 'translateY(0)';
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.parentElement.style.paddingBottom = ''; // rt-cls-sticky-slot:v1
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.classList.remove('scrolled-past-header');
      this.header.style.position = '';
      this.header.style.top = '';
      this.header.style.left = '';
      this.header.style.right = '';
      this.header.style.width = '';
      this.header.style.zIndex = '';
      this.header.style.transition = '';
      this.header.style.transform = '';
      this.fixedActive = false;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
